import React, { useEffect } from "react";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { Switch, Route } from "@components/router";
import FinancialOverview from "./FinancialOverview";
import ProductionOverview from "./ProductionOverview";
import stateBusiness, { pageData, EPages } from "./state";
import { authState } from "@state/auth";
import api from "@api";

const Routes = () => {
  const page = useRecoilValue(stateBusiness);
  const [data, setData] = useRecoilState(pageData);
  const auth = useRecoilValue(authState);

  const getData = async () => {
    const { data, status } = await api.postOverview({
      gameid: auth.gameid,
      userid: auth.userid
    });
    if (status == 200) {
      setData({
        production_overview: data.production_overview,
        financial_overview: data.costs
      });
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <Switch value={page}>
      <Route
        routeValue={EPages.PRODUCTION_OVERVIEW}
        Component={ProductionOverview}
      />
      <Route
        routeValue={EPages.FINANCIAL_OVERVIEW}
        Component={FinancialOverview}
      />
    </Switch>
  );
};

export default Routes;
